import { Component, Input, SimpleChanges } from '@angular/core';
import {
    AutomaticMissionConfigurationDto,
    FlightLogCollectionService,
    FlightLogCollectionSourceDto,
    FlyFreelyError,
    FlyFreelyLoggingService,
    OrganisationAutomaticMissionConfigurationDto,
    ResultDto,
    WorkTracker
} from '@flyfreely-portal-ui/flyfreely';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import {
    FlightLogSettingsService,
    automaticMissionSettingsTypeDisplayableNames
} from './flight-log-settings.service';

@Component({
    selector: 'automatic-mission-assignment-settings',
    template: `
        <!-- <div class="horizonal-container vertical-align">
            <button
                type="button"
                class="btn btn-inline btn-link"
                (click)="showSettings()"
                [disabled]="working"
                tooltip="Adjust auto mission creation settings"
                placement="top"
            >
                {{ currentConfigLabel }}
            </button>
        </div> -->
        <div class="horizonal-container vertical-align">
            {{ currentConfigLabel }} |
            <button
                type="button"
                class="btn btn-inline btn-link"
                (click)="showSettings()"
                [disabled]="working"
                tooltip="Adjust auto mission creation settings"
                placement="top"
            >
                Change
            </button>
        </div>
    `
})
export class AutomaticMissionCreationSettingsComponent {
    @Input() entry: FlightLogCollectionSourceDto;
    @Input()
    defaultOrganisationConfig: OrganisationAutomaticMissionConfigurationDto;
    working: boolean;

    currentConfig: AutomaticMissionConfigurationDto;

    currentConfigLabel: string;

    private workTracker = new WorkTracker();
    ngUnsubscribe$ = new Subject<void>();
    constructor(
        private flightLogSettingsService: FlightLogSettingsService,
        private flightLogCollectionService: FlightLogCollectionService,
        private logging: FlyFreelyLoggingService
    ) {
        this.workTracker.observable
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(working => (this.working = working));
    }

    ngOnInit() {
        this.refreshFlightLogMissionConfiguration();
        this.flightLogCollectionService.change$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(() => this.refreshFlightLogMissionConfiguration());
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('defaultOrganisationConfig' in changes) {
            this.updateCurrentConfigLabel();
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    refreshFlightLogMissionConfiguration() {
        this.flightLogCollectionService
            .findAutomaticMissionConfiguration(this.entry.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: configs => {
                    this.currentConfig = configs;
                    this.updateCurrentConfigLabel();
                }
            })
            .add(this.workTracker.createTracker());
    }

    updateCurrentConfigLabel() {
        if (this.currentConfig == null) {
            return;
        }
        if (
            this.currentConfig.type !==
                AutomaticMissionConfigurationDto.Type.ORGANISATION_DEFAULT ||
            this.defaultOrganisationConfig == null
        ) {
            this.currentConfigLabel =
                automaticMissionSettingsTypeDisplayableNames[
                    this.currentConfig.type
                ];
        } else {
            this.currentConfigLabel = `${
                automaticMissionSettingsTypeDisplayableNames[
                    this.defaultOrganisationConfig.type
                ]
            } (default)`;
        }
    }

    showSettings() {
        this.flightLogSettingsService.showAutomaticMissionConfigurationSettings(
            this.entry,
            this.currentConfig
        );
    }

    createMissionsNow() {
        this.flightLogCollectionService
            .applyAutomaticMissionConfiguration(
                this.currentConfig.collectionSourceId
            )
            .pipe(take(1), takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (result: ResultDto) => {
                    this.logging.success(
                        `Successfully created ${result.value} missions`
                    );
                },
                error: (error: FlyFreelyError) => {
                    this.logging.error(
                        error,
                        `Error while creating missions: ${error.message}`
                    );
                }
            })
            .add(this.workTracker.createTracker());
    }
}
